import { useMemo } from 'preact/hooks';
import { ComponentMessageItem } from '../../UNSAFE_ComponentMessage';

const rankedSeverities = ['error', 'warning', 'confirmation', 'info', 'none'] as const;

export function useMessageSeverity(messages?: ComponentMessageItem[]) {
  return useMemo(() => {
    return messages === undefined
      ? undefined
      : messages.reduce<typeof rankedSeverities[number]>((accSeverity, currMessage) => {
          const currSeverity = currMessage.severity || 'error';
          return rankedSeverities.indexOf(accSeverity) < rankedSeverities.indexOf(currSeverity)
            ? accSeverity
            : currSeverity;
        }, 'none');
  }, [messages]);
}
